import React, { useState, useEffect } from "react";
import axios from "../../utils/request";
import "./index.css";
import { en, ch } from "../../utils/content";
import { Link, useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  const [companyInfo, setCompanyInfo] = useState<any>({});
  const [firstTabs, setFirstTabs] = useState<any>([]);
  const getTabs = async () => {
    const res: any = await axios.get("/index/product/class");
    if (res.code === 200) {
      setFirstTabs(res.data);
    }
  };
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/index/site");
      if (res.code === 200) {
        setCompanyInfo(res.data);
      }
    };
    initData();
    getTabs();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="footer">
      <div className="container">
        <div className="left">
          <div className="top-text1">{TXT_INFO.help}</div>
          <div className="top-text2">{companyInfo.phone}</div>
          <div className="top-text5">
            {TXT_INFO.transmissionOfTruth}：{companyInfo.fax}
          </div>
          <div className="top-text3">
            {TXT_INFO.email}：{companyInfo.email}
          </div>
          <div className="top-text3">
            {TXT_INFO.site}：{companyInfo.address}
          </div>
          <div className="erm-box">
            <img className="erm-img" src={companyInfo.wechat} alt="联系微信" />
            <div className="top-text5">{TXT_INFO.wx}</div>
          </div>
        </div>
        <div className="right">
          <div className="right-item">
            <span className="top-text6">{TXT_INFO.footer.about}</span>
            {TXT_INFO.footer.aboutList.map((item: any, index: number) => {
              return (
                <Link to="/about">
                  <span>{item}</span>
                </Link>
              );
            })}
          </div>
          {/* <div className="right-item">
            <span className="top-text6">新闻中心</span>
            <Link to="/news">
              <span>公司新闻</span>
            </Link>
            <Link to="/news">
              <span>行业资讯</span>
            </Link>
            <Link to="/news">
              <span>企划宣传</span>
            </Link>
            <Link to="/news">
              <span>营销知识</span>
            </Link>
            <Link to="/news">
              <span>综合新闻</span>
            </Link>
          </div> */}
          <div className="right-item">
            <span className="top-text6">{TXT_INFO.footer.product}</span>
            {firstTabs.map((item: any) => {
              return (
                <div
                  className="ri-title"
                  onClick={() => {
                    navigate("/product", {
                      state: {
                        id: item?.id,
                      },
                    });
                  }}
                >
                  <span>{item.title}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="bottom">
        <div>Copyright ©{companyInfo.company_name}</div>
        <Link className="icp" to="https://beian.miit.gov.cn" target="_blank">
          <span>
            {TXT_INFO.beianhao} {TXT_INFO.bah_num}
          </span>
        </Link>
      </div>
    </div>
  );
};
export default Footer;
